"use client";
import { languages } from "@/app/constants";
import { Link } from "@/app/config/navigation";
import React from "react";
import Language from "./Language";
import SocialMedia from "./SocialMedia";
import ContactIcon from "./ContactIcon";
import { useTranslations } from "next-intl";
export type SidebarFooterPropsType = { menuOnClick?: () => void };
export function SidebarFooter({ menuOnClick }: SidebarFooterPropsType) {
  const t = useTranslations("layout");

  return (
    <div className="bg-secondary text-white h-auto  lg:h-[40%]">
      <div className="container lg:py-20 lg:pb-20 py-[3rem] pb-[6rem]">
        <SocialMedia />
        <div className="grid grid-rows-1 grid-cols-4">
          <div className="col-span-3">
            <div className="flex gap-7 lg:gap-5 items-center mb-11">
              {" "}
              {languages.map((language, index) => (
                <Language {...language} key={language.key} />
              ))}
            </div>
            <div className="flex  gap-11 text-gray200  text-[12px] md:text-[21px]">
              <Link onClick={menuOnClick} href="/privacy-policy" className="">
                {t("privacyPolicy")}
              </Link>
              <Link onClick={menuOnClick} href="/terms-and-conditions" className="">
                {t("termsConditions")}
              </Link>
            </div>
          </div>
          <div className="col-span-1 flex flex-col items-center">
            <ContactIcon className="mb-[16px] " />
            <p className="m-0  text-[12px]	md:text-[21px]"> {t("contactUs")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
